'use client'

import { NotificationProps } from '@mantine/core'
import { NotificationData, notifications } from '@mantine/notifications'
import {
  faCircleCheck,
  faCircleExclamation,
  faInfoCircle,
  faTriangleExclamation,
} from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classes from './notification-alerts.module.css'

/**
 * Note: These functions can only be imported and used in applications that have been setup with Mantine's notifications system (https://mantine.dev/x/notifications/)
 * Both Terrace and Courtyard2 have the required <Notifications /> component defined within the MantineProvider at the root layout.
 */

type NotifyErrorPropsBase = {
  id?: NotificationData['id']
  title?: NotificationData['title']
  message?: NotificationData['message']
  icon?: NotificationProps['icon']
  autoClose?: NotificationData['autoClose']
  withCloseButton?: NotificationData['withCloseButton']
}
type NotifyErrorProps = NotifyErrorPropsBase &
  ({ title: NotificationData['title'] } | { message: NotificationData['message'] })

export const notifySuccess = ({
  id,
  title,
  message,
  icon,
  autoClose = false,
  withCloseButton = true,
}: NotifyErrorProps) =>
  notifications.show({
    id,
    title,
    message,
    autoClose,
    withCloseButton,
    icon: icon || <FontAwesomeIcon icon={faCircleCheck} />,
    color: 'green.3',
    classNames: classes,
  })

export const notifyInfo = ({ id, title, message, icon, autoClose = false, withCloseButton = true }: NotifyErrorProps) =>
  notifications.show({
    id,
    title,
    message,
    autoClose,
    withCloseButton,
    icon: icon || <FontAwesomeIcon icon={faInfoCircle} />,
    color: 'blue.1',
    classNames: classes,
  })

export const notifyWarn = ({ id, title, message, icon, autoClose = false, withCloseButton = true }: NotifyErrorProps) =>
  notifications.show({
    id,
    title,
    message,
    autoClose,
    withCloseButton,
    icon: icon || <FontAwesomeIcon icon={faTriangleExclamation} />,
    color: 'tan.3',
    classNames: classes,
  })

export const notifyError = ({
  id,
  title,
  message,
  icon,
  autoClose = false,
  withCloseButton = true,
}: NotifyErrorProps) =>
  notifications.show({
    id,
    title,
    message,
    autoClose,
    withCloseButton,
    icon: icon || <FontAwesomeIcon icon={faCircleExclamation} />,
    color: 'red.2',
    classNames: classes,
  })
